import React, { useState } from 'react';

const sections = [
  {
    title: '1. Acceptance of Terms',
    content: (
      <p>
        By purchasing or using the service, users agree to be bound by these Terms and Conditions and any future updates or modifications.
      </p>
    ),
  },
  {
    title: '2. Service Description',
    content: (
      <p>
        Pitics offers Instant Online Notebook Label Stickers, allowing users to customize and generate QR code-based sticker labels.
      </p>
    ),
  },
  {
    title: '3. Field Character Limits and Naming Conventions',
    content: (
      <ul className="list-disc pl-5 space-y-1">
        <li>All input fields in the app allow a maximum of 25 characters.</li>
        <li>Admission Number and Semester combined must not exceed 25 characters.</li>
        <li>Use a shortened version of surname if full name exceeds 25 characters.</li>
        <li>Use subject abbreviations (e.g., E.V.S. instead of Evs) with dots for capitalization.</li>
      </ul>
    ),
  },
  {
    title: '4. QR Code Usage and Data Display',
    content: (
      <ul className="list-disc pl-5 space-y-1">
        <li>QR codes show Name, Study, and Dream fields with personalized surprises.</li>
        <li>In rare cases, QR codes may fail to generate due to technical issues.</li>
      </ul>
    ),
  },
  {
    title: '5. Pricing, Refunds, and Promo Codes',
    content: (
      <ul className="list-disc pl-5 space-y-1">
        <li>All payments are final. No refunds will be provided under any circumstances.</li>
        <li>Prices may change to promote offers and reach more students.</li>
        <li>Promo codes may change or be canceled anytime without notice.</li>
      </ul>
    ),
  },
  {
    title: '6. Refunds and Cancellations',
    content: (
      <>
        <p className="mb-1 font-medium">No Refunds Policy:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Change of mind or dissatisfaction after purchase</li>
          <li>Technical issues like QR code generation failures</li>
          <li>Incorrect data input or character limit issues</li>
          <li>Service interruptions or maintenance</li>
          <li>Price or promo changes</li>
        </ul>
        <p className="mt-2">
          Cancellations are allowed, but no refunds for current billing period. All fees are non-refundable.
        </p>
      </>
    ),
  },
  {
    title: '7. User Responsibilities',
    content: (
      <ul className="list-disc pl-5 space-y-1">
        <li>Provide accurate and complete information</li>
        <li>Use the service legally and ethically</li>
      </ul>
    ),
  },
  {
    title: '8. Access and Usage',
    content: (
      <ul className="list-disc pl-5 space-y-1">
        <li>Service is delivered instantly upon payment</li>
        <li>Pitics may restrict or suspend access if terms are violated</li>
      </ul>
    ),
  },
  {
    title: '9. Intellectual Property',
    content: (
      <ul className="list-disc pl-5 space-y-1">
        <li>All content is owned by Pitics Technologies</li>
        <li>Do not copy, modify, or redistribute without permission</li>
      </ul>
    ),
  },
  {
    title: '10. Privacy and Data Protection',
    content: (
      <>
        <p><strong>Data Collection and Use:</strong> We only collect necessary information for registration and service delivery, which is stored securely.</p>
        <p><strong>Strict Confidentiality:</strong> We do not sell, share, or disclose your information under any circumstances, except as required by law.</p>
        <p><strong>Privacy Policy:</strong> See our <a href="#" className="text-blue-600 underline">Privacy Policy</a> for full details.</p>
      </>
    ),
  },
  {
    title: '11. Disclaimer of Warranties',
    content: (
      <ul className="list-disc pl-5 space-y-1">
        <li>Service is provided “as is” without guarantees</li>
        <li>No warranty on uptime or accuracy</li>
      </ul>
    ),
  },
  {
    title: '12. Limitation of Liability',
    content: <p>We are not liable for damages resulting from use or inability to use the service.</p>,
  },
  {
    title: '13. Termination',
    content: (
      <ul className="list-disc pl-5 space-y-1">
        <li>Either party may terminate the agreement</li>
        <li>Termination ends access with no refund for current period</li>
      </ul>
    ),
  },
  {
    title: '14. Changes to Terms',
    content: (
      <ul className="list-disc pl-5 space-y-1">
        <li>We may modify terms anytime, with or without notice</li>
        <li>Continued use means acceptance of updated terms</li>
      </ul>
    ),
  },
  {
    title: '15. Contact Information',
    content: (
      <p>
        reach us at:<br />
        📧 <a href="mailto:support@pitics.com" className="text-blue-600 underline">support@pitics.com</a><br />
        🌐 <a href="https://www.pitics.com" className="text-blue-600 underline">www.pitics.com</a>
      </p>
    ),
  },
];

const TermsAndConditions = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-2xl shadow-md mt-6 mb-10 text-gray-800">
      <h1 className="text-[12px] font-bold mb-4 text-left">Terms and Conditions</h1>
      <div className="space-y-5 text-sm leading-relaxed max-h-[70vh] overflow-y-auto pr-2">
        {sections.map((section, index) => (
          <div key={index}>
            <h2
              className="font-semibold text-[12px] mb-1 cursor-pointer flex items-center gap-2 text-left text-blue-700"
              onClick={() => toggleSection(index)}
            >
              {section.title}
              <span className="text-xs">{openIndex === index ? '▲' : '▼'}</span>
            </h2>
            {openIndex === index && (
              <div className="transition-all duration-300 ease-in-out">{section.content}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TermsAndConditions;
